import { useState } from "react";
import * as v from "valibot";
import { valibotResolver } from "@hookform/resolvers/valibot";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { Input } from "../../common/input/Input";
import { CustomToast } from "../../common/customToast/CustomToast";
import { Select } from "../../common/select/Select";
import { useGetAllUserQuery } from "../../../features/api/user/userApi";
import { useAddCapitalMutation } from "../../../features/api/capital/capitalApi";
import { useGetAllPaymentMethodQuery } from "../../../features/api/order/payment/paymentMethodApi";

const schema = v.object({
  note: v.pipe(
    v.string("Note is required"),
    v.minLength(3, "At least 3 letters is required"),
    v.maxLength(255, "Maximum 255 chararcter allowed")
  ),
  amount: v.pipe(
    v.number("Amount is required"),
    v.minValue(1, "The amount must be greater than zero")
  ),
  intakeMethod: v.pipe(
    v.string("Intake method is required"),
    v.minLength(2, "Intake method is required")
  ),

  contributedBy: v.pipe(
    v.string("Contributed by is required"),
    v.minLength(2, "Contributed by is required")
  ),
});

export const AddCapital = ({ onSuccess }) => {
  const [capital, setCapital] = useState({
    note: "",
    amount: 0,
    intakeMethod: "",
    contributedBy: "",
  });
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: capital,
    resolver: valibotResolver(schema),
  });

  const {
    data: paymentMethods,
    isLoading: isPaymentMethodsLoading,
    isError: isPaymentMethodsError,
  } = useGetAllPaymentMethodQuery();

  const {
    data: userData,
    isLoading: isUserDataLoading,
    isError: isUserDataLoadingError,
  } = useGetAllUserQuery();
  const [addCapital, { isLoading, isSuccess, isError, error }] =
    useAddCapitalMutation();
  const onSubmit = async (data) => {
    try {
      await addCapital(data).unwrap();
      setTimeout(() => {
        onSuccess();
      }, 5000);
    } catch (err) {}
    reset();
  };

  return (
    <div className="mb-5">
      <Container className="mt-5 shadow-sm">
        {isSuccess && <CustomToast msg={"Added to capital successfully!"} />}
        {isError && <CustomToast err={error} msg={error.data.errorMessage} />}
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row>
            <Col lg={6} md={6} xs={12}>
              <Input
                label={"Amount"}
                type={"number"}
                withUnit={true}
                field={"amount"}
                register={register}
                defaultValue={capital.amount}
                error={errors.amount}
              />

              <Select
                label="Contributed by"
                field="contributedBy"
                register={register}
                options={
                  isUserDataLoading
                    ? [
                        {
                          value: "",
                          label: "Loading contributors...",
                        },
                      ]
                    : isUserDataLoadingError
                    ? [{ value: "", label: "Failed to load users" }]
                    : userData?.map((user) => ({
                        value: `${user.firstName} ${user.lastName}`,
                        label: `${user.firstName} ${user.lastName}`,
                      })) ?? []
                }
                errors={errors}
              />
            </Col>
            <Col lg={6} md={6} xs={12}>
              <Input
                label={"Note"}
                field={"note"}
                register={register}
                defaultValue={capital.note}
                error={errors.note}
              />

              <Select
                label="Intake method"
                field="intakeMethod"
                register={register}
                options={
                  isPaymentMethodsLoading
                    ? [{ value: "", label: "Payment methods loading..." }]
                    : isPaymentMethodsError
                    ? [{ value: "", label: "Failed to load payment methods" }]
                    : paymentMethods?.map((method) => ({
                        value: method?.name ?? method,
                        label: method?.name ?? method,
                      })) ?? []
                }
                errors={errors}
              />
            </Col>
          </Row>
          <Row className="py-2">
            <Col lg={12}>
              <Button
                type="submit"
                variant="success"
                className="w-100"
                disabled={isLoading}
              >
                {isLoading ? "Saving" : "Submit"}
              </Button>
            </Col>
          </Row>
        </Form>
      </Container>
    </div>
  );
};
